import { render, staticRenderFns } from "./editFieldsModal.vue?vue&type=template&id=6a1c1a48&scoped=true&"
import script from "./editFieldsModal.vue?vue&type=script&lang=js&"
export * from "./editFieldsModal.vue?vue&type=script&lang=js&"
import style0 from "./editFieldsModal.vue?vue&type=style&index=0&id=6a1c1a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1c1a48",
  null
  
)

export default component.exports